<template>
  <div>
    <a-spin :spinning="loading" :key="selectedExamIds">
      <div class="neo-tabs">
        <a-tabs
          :defaultActiveKey="undefined"
          :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'"
          @change="handleStudentChange"
        >
          <a-tab-pane tab="All students" :key="undefined">
            <student-marks-display-all
              :examData="classExamData"
              :studentsData="classStudents"
            />
          </a-tab-pane>
          <a-tab-pane
            v-for="student in classStudents"
            :tab="
              `${student.student.first_name} ${student.student.last_name} (${
                student.roll_no ? student.roll_no : ''
              })`
            "
            :key="student.id"
          >
            <student-marks-display-single
              :allExamData="allExamData"
              :studentData="student"
              :examData="classExamData"
              :allExams="allExams"
              :reportsData="reportsData"
              :remarksData="remarksData"
              :selectedId="selectedExamIds"
              :getStudent_ExamDetails="getStudentExamDetails"
              :reportCardFormat="reportCardFormat"
              :classId="classId"
              :sessionId="sessionId"
              :classSubjectList="classSubjectList"
            />
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { omit } from 'lodash'
import { mapState } from 'vuex'

import StudentMarksDisplaySingle from '@/components/bosemexam/manage/BethelReport/DisplaySingle/index'
import StudentMarksDisplayAll from '@/components/bosemexam/manage/BethelReport/DisplayAll/index'

// import EditExamRemark from '@/components/exam/manage/Report/Remark/Edit/index'

export default {
  name: 'DisplayStudentExamReport',
  props: ['examData', 'selectedExamId', 'classId', 'selectedReportCardFormat', 'sessionId'],
  components: {
    StudentMarksDisplaySingle,
    StudentMarksDisplayAll,
    // EditExamRemark,
  },
  watch: {
    classId: function(value) {
      return value
    },
    sessionId: function(value) {
      return value
    },

    allExamData: function(value) {
      return value
    },
    studentEnrollId: function(value) {
      return value
    },
    allExams: function(value) {
      return value
    },
    getStudentExamDetails: function(value) {
      return value
    },
  },
  data: function() {
    return {
      loading: false,
      classSectionExamData: null,
      selectedStudentEnrollmentId: null,
      reportsData: null,
      remarksData: null,
      activeKey: [undefined],
      allExamData: [],
      studentEnrollId: '',
      allExams: [],
      counts: null,
      getStudentExamDetails: [],
      classSubjectList: [],
    }
  },
  computed: {
    ...mapState(['settings']),
    classStudents: function() {
      return this.examData.students
    },
    classExamData: function() {
      return omit(this.examData, ['students'])
    },
    selectedExamIds: function() {
      return omit(this.selectedExamId)
    },
    examIdSelected: function() {
      return this.selectedExamId
    },
    reportCardFormat: function() {
      return this.selectedReportCardFormat
    },
  },
  mounted: function() {
    this.studentReports()
  },
  methods: {
    getAllExamMarksForStudent(enrollId) {
      this.allExamData = []
      this.selectedExamId.forEach((value, index) => {
        this.$http
          .get(`/api/studentexammark/${enrollId}`, {
            params: {
              class_section_exam_id: value,
            },
          })
          .then(({ data }) => {
            this.allExamData.push(data.data)
            this.loading = false
          })
      })
    },
    getClassSubjects() {
      if (`${this.classId}`) {
        this.$http
          .get(`/api/subject/class/${this.classId}?${this.session_Id}`)
          .then(({ data }) => {
            this.classSubjectList = data.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    classSectionExamAllData() {
      this.allExams = []

      this.selectedExamId.forEach((value, index) => {
        this.$http
          .get(`/api/classsectionexam/${value}`, {
            params: {
              with_students: 1,
              class_section_exam_id: this.value,
            },
          })
          .then(({ data }) => {
            this.allExams.push(data.data)
            this.counts = this.counts + 1
          })
        // .catch((error) => {
        //   console.log(error);
        // });
      })
    },
    handleStudentChange(student) {
      if (student) {
        this.selectedStudentEnrollmentId = student
        this.studentEnrollId = student
        this.classSectionExamAllData()
        this.getStudentExamReport(student)
        this.getStudentRemarks(student)
        this.getAllExamMarksForStudent(student)
        this.studentReports()
        this.getClassSubjects()
      }
    },
    studentReports() {
      this.$http
        .get(
          `/api/reports/student/exams?enrollment_id=${this.studentEnrollId}`,
          {
            params: {
              // enrollment_id: student,
              class_section_exams: this.selectedExamId,
              session_id: this.sessionId,
            },
          }
        )
        .then(({ data }) => {
          this.getStudentExamDetails = data.data
        })
        // .catch(error => {
        //   console.log(error);
        // });
    },
    getStudentExamReport(enrollmentId) {
      this.loading = true
      // single data
      this.$http
        .get(`/api/reports/student/exam/${this.examData.id}`, {
          params: {
            enrollment_id: enrollmentId,
            session_id: this.sessionId,
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.reportsData = data.data
        })
    },
    getStudentRemarks(enrollmentId) {
      this.loading = true
      this.$http
        .get(`/api/studentexamremarks/${enrollmentId}`, {
          params: {
            class_section_exam_id: this.examData.id,
            session_id: this.sessionId,
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.remarksData = data.data
        })
      // .catch((error) => {
      //   console.log(error);
      // });
    },
    handleUpdateRemarksTable() {
      this.getStudentRemarks(this.selectedStudentEnrollmentId)
    },
  },
}
</script>
